export default function useLineChartOptions() {
    return {
        yAxis: {
            allowDecimals: false,
        },
        chart: {
            type: 'line',
        },
    };
}
